import { APIScope } from "@swivl-mono/types";
import { FormFieldWidth, Spinner } from "@swivl-mono/ui";
import { DateTime } from "luxon";
import { useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

import { QuestsDropdown } from "../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import { useHasPermission } from "../../../../Helpers/Permissions/useHasPermission";
import { Member } from "../../../../Models/Member/Member.Current";
import { QuestsModel } from "../../../../Models/Quests/Quests.Model";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";
import { SequenceAdminTools } from "../Components/Sequence.AdminTools";
import { ComponentsForSequenceType } from "../Types/SequencePastDue";

export function SequenceDetailsView() {
  const { sequences, sequenceRecords } = SequencesModel.useState();
  const { quests } = QuestsModel.useState(); // use this to make sure they are loaded before we display
  const sequenceId = useParams<{ sequenceId: string }>().sequenceId;
  const canEditSequences = useHasPermission(APIScope.SEQUENCES_EDIT);

  useEffect(() => {
    SequencesModel.load(false);
    QuestsModel.loadQuestsList(false);
  }, []);

  useEffect(() => {
    if (sequenceId) {
      SequencesModel.loadSequenceRecordsForSequence(parseInt(sequenceId));
    }
  }, [sequenceId]);

  const sequence = useMemo(() => {
    if (!sequenceId || !sequences) return undefined;
    return sequences[sequenceId];
  }, [sequences, sequenceId]);

  const records = useMemo(() => {
    if (!sequenceId || !sequenceRecords) return [];

    return sequenceRecords[sequenceId] || [];
  }, [sequenceRecords, sequenceId]);

  if (!sequence || !quests)
    return (
      <div className="p-5">
        <label>Sequence Details</label>
        <Spinner />
      </div>
    );

  return (
    <div className="p-5">
      <label>Sequence Details</label>
      <h1>{sequence.name}</h1>
      {sequence && <ComponentsForSequenceType sequence={sequence} />}

      <label className="mt-5">Quest</label>

      <QuestsDropdown
        value={sequence?.questSlug}
        width={FormFieldWidth.RESPONSIVE_240}
        disableEditing={!canEditSequences}
        optionSelected={(option) => {
          SequencesModel.updateSequence(sequence.id, { questSlug: option.value }, true);
        }}
      />

      {Member.isSwivlStaff && <SequenceAdminTools sequence={sequence} />}

      <h3 className="my-2 text-lg font-semibold text-grey-800">Records</h3>
      {records.map((record) => (
        <Link key={record.id} to={`/settings/sequences/${sequenceId}/record/${record.id}`}>
          <div className="SequenceRecordListItem mb-3 rounded-md bg-white p-3 hover:bg-orange-100">
            <div className="font-semibold text-black">
              Sent to {record.eventsCreated} users on {DateTime.fromISO(record.createdAt as unknown as string).toFormat("L/d/yy @ t")}{" "}
            </div>
            {record.eventsCreated !== record.numberOfUsers ? (
              <div className="warning float-right">
                Not all users were sent {record.eventsCreated} / {record.numberOfUsers}
              </div>
            ) : null}
          </div>
        </Link>
      ))}
    </div>
  );
}
